exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pageForbidden_from_errors-css_34x {\r\n  position: relative;\r\n  height: 100vh;\r\n}\r\n\r\n.pageForbidden__inner_from_errors-css_xIJ {\r\n  position: absolute;\r\n  width: 320px;\r\n  left: 50%;\r\n  top: 50%;\r\n  -webkit-transform: translate(-50%, -50%);\r\n          transform: translate(-50%, -50%);\r\n}\r\n\r\n.pageForbidden__option_from_errors-css_3q7 {\r\n  color: black;\r\n  padding: 4px 0;\r\n}\r\n\r\n.pageNotFound_from_errors-css_iTp {\r\n  position: relative;\r\n  height: 100vh;\r\n}\r\n\r\n.pageNotFound__inner_from_errors-css_3tc {\r\n  position: absolute;\r\n  width: 320px;\r\n  left: 50%;\r\n  top: 50%;\r\n  -webkit-transform: translate(-50%, -50%);\r\n          transform: translate(-50%, -50%);\r\n}\r\n\r\n.errors_from_errors-css_3hO {}\r\n", ""]);

// exports
exports.locals = {
	"pageForbidden": "pageForbidden_from_errors-css_34x",
	"pageForbidden__inner": "pageForbidden__inner_from_errors-css_xIJ",
	"pageForbidden__option": "pageForbidden__option_from_errors-css_3q7",
	"pageNotFound": "pageNotFound_from_errors-css_iTp",
	"pageNotFound__inner": "pageNotFound__inner_from_errors-css_3tc",
	"errors": "errors_from_errors-css_3hO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/styles/errors/errors.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/styles/errors/errors.css
// module chunks = 0